import { property as s } from "../beacon-property.d/index.js";
import { p as d, a as p } from "./lifecycle-decorators-CUsT9aHq.js";
import { B as m } from "./form-associated-L7I3gs1I.js";
var h = /* @__PURE__ */ ((l) => (l.TEXT = "text", l.URL = "url", l.NUMBER = "number", l.EMAIL = "email", l.TEL = "tel", l.PASSWORD = "password", l))(h || {}), g = Object.defineProperty, f = Object.getOwnPropertyDescriptor, i = (l, t, e, r) => {
  for (var n = r > 1 ? void 0 : r ? f(t, e) : t, o = l.length - 1, u; o >= 0; o--)
    (u = l[o]) && (n = (r ? u(t, e, n) : u(n)) || n);
  return r && n && g(t, e, n), n;
};
class a extends m {
  constructor() {
    var t;
    super(...arguments), this.value = "", this.label = "", this.hint = "", this.type = h.TEXT, this.pattern = void 0, this.invalid = !((t = this.internals) != null && t.checkValidity()), this.disabled = !1, this.required = !1, this.defaultMessages = {
      required: "This field is required",
      min: "Minimum %X% required",
      max: "Maximum %X% allowed",
      minlength: "Minimum %X% required",
      maxlength: "Maximum %X% allowed",
      noMatchPattern: "Pattern does not match",
      minDate: "Date must be on or after %X%",
      maxDate: "Date must be on or before %X%"
    }, this.errorsMap = {}, this.requiredMessage = "This field is required", this.disableDefaultValidation = !1, this.validateOnSubmit = !1, this.updatePreventDisabled = (e) => {
      e.target.disabled || this.captureEventValue(e);
    };
  }
  static get styles() {
    return [...super.styles];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles];
  }
  /**
   * Creates a string value from the disabled state.
   *
   * This is useful when used to set attributes using Lit's `live` directive.
   * That directive should only be passed strings in cases of attribute expressions, not booleans.
   * @link https://lit.dev/docs/templates/directives/#live
   */
  get disabledStateAsString() {
    return this.disabled ? "true" : "false";
  }
  /**
   * Creates a string value from the invalid state.
   *
   * @see disabledStateAsString.
   */
  get invalidStateAsString() {
    return this.invalid ? "true" : "false";
  }
  /**
   * Runs all form validations, should be linked to the event triggering validation.
   */
  evaluateValidations() {
    this.internals && (this.disableDefaultValidation ? this.customValidate && (this.customValidate({ internals: this.internals, value: this.value, target: this }), this.requestUpdate("invalid")) : (this.requiredValidation(), this.minValidation(), this.maxValidation(), this.minLengthValidation(), this.maxLengthValidation(), this.patternValidation(), this.customValidate && this.customValidate({ internals: this.internals, value: this.value, target: this }), this.requestUpdate("invalid")));
  }
  /**
   * Resets the form validation state and sets the invalid attribute to false
   */
  resetValidations() {
    var t;
    (t = this.internals) != null && t.validity.valid || this.setValidity({});
  }
  updateValidity(t, e) {
    this.setValidity(t, e), this.requestUpdate("invalid");
  }
  setFormValue() {
    this.internals && this.internals.setFormValue(this.value);
  }
  prerenderFormBaseSetup() {
    var t;
    this.internals && (this.validateOnSubmit = !!((t = this.internals) != null && t.form));
  }
  /**
   * Calls prevent default on all non keyboard interactive events triggered
   * when this component is disabled.
   * @param event
   */
  preventDisabledEvents(t) {
    let e;
    const r = ["Shift", "Tab"];
    t && t instanceof KeyboardEvent && (e = t.key), this.disabled && e && (r.includes(e) || t.preventDefault());
  }
  /**
   * Sets the internal form value to the captured input event and emits
   * a beacon-event-input
   * @param event
   * @event {BeaconEvent} beacon-event-input - emits an input event
   */
  handleInput(t) {
    this.captureEventValue(t), this.emitInput(t, { internals: this.internals, value: this.value, target: t.target }), this.requestUpdate("invalid");
  }
  /**
   * Sets the form value to the value of the captured event target
   * @param event
   */
  captureEventValue(t) {
    var e;
    this.internals && (this.value = (e = t == null ? void 0 : t.target) == null ? void 0 : e.value, this.internals.setFormValue(this.value));
  }
  /**
   * Attempts to set the form value from the event with captureEventValue
   * Dispatches a change event with composed property set to true if the component is nested in a shadow-root in
   * order to permeate across nested web components.
   * @param event
   * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
   */
  handleChange(t) {
    const e = this.getRootNode();
    if (e != null && e.host && t.isTrusted && t.target) {
      const r = new Event("change", { bubbles: !0, composed: !0 });
      t.target.dispatchEvent(r);
    }
    this.captureEventValue(t), this.emitChange(t, { internals: this.internals, value: this.value, target: t == null ? void 0 : t.target }), this.requestUpdate("invalid");
  }
  /**
   * Attempts to run validations or reset validations then emits a beacon-event-blur
   * @param event
   * @event {BeaconEvents} beacon-event-blur - emits when a standard blur event would be fired
   */
  handleBlur(t) {
    this.validateOnSubmit || this.evaluateValidations(), this.emitBlur(t, { internals: this.internals, value: this.value, target: t == null ? void 0 : t.target }), this.requestUpdate("invalid");
  }
  /**
   * Displays the required validation error if the required value is missing
   * and prevents submission by setting this.invalid accordingly
   */
  requiredValidation() {
    var t;
    if (!this.value && this.required) {
      const e = ((t = this.errorsMap) == null ? void 0 : t.required) || this.defaultMessages.required;
      this.setValidity({ valueMissing: !0 }, e);
    } else
      this.setValidity({ valueMissing: !1 });
  }
  /**
   * Displays the min error message if the min number validation fails for a number input
   * and prevents submission by setting this.invalid accordingly
   */
  minValidation() {
    var e;
    const t = this.value && +this.value;
    if (this.type === h.NUMBER && this.value && this.min && t < this.min) {
      const r = this.errorsMap.min || ((e = this.defaultMessages.min) == null ? void 0 : e.replace("%X%", this.min.toString()));
      this.setValidity({ rangeUnderflow: !0 }, r);
    }
  }
  /**
   * Displays the max error message if the max number validation fails for a number input
   * and prevents submission by setting this.invalid accordingly
   */
  maxValidation() {
    var e;
    const t = this.value && +this.value;
    if (this.type === h.NUMBER && this.value && this.max && t > this.max) {
      const r = this.errorsMap.max || ((e = this.defaultMessages.max) == null ? void 0 : e.replace("%X%", this.max.toString()));
      this.setValidity({ rangeOverflow: !0 }, r);
    }
  }
  /**
   * Displays the min length validation error message if the min length validation fails for a text input
   * and prevents submission by setting this.invalid accordingly
   */
  minLengthValidation() {
    var t;
    if (this.value && this.minlength && this.value.length < this.minlength) {
      const e = this.errorsMap.minlength || ((t = this.defaultMessages.minlength) == null ? void 0 : t.replace("%X%", this.minlength.toString()));
      this.setValidity({ tooShort: !0 }, e);
    }
  }
  /**
   * Displays the max length validation error message if the max length validation fails for a text input
   * and prevents submission by setting this.invalid accordingly
   */
  maxLengthValidation() {
    var t;
    if (this.value && this.maxlength && this.value.length > this.maxlength) {
      const e = this.errorsMap.maxlength || ((t = this.defaultMessages.maxlength) == null ? void 0 : t.replace("%X%", this.maxlength.toString()));
      this.setValidity({ tooLong: !0 }, e);
    }
  }
  /**
   * Displays the pattern validation error message if the regex pattern match fails
   * and prevents submission by setting this.invalid accordingly
   */
  patternValidation() {
    if (this.value && this.pattern && !new RegExp(this.pattern).test(this.value)) {
      const t = this.errorsMap.noMatchPattern || this.defaultMessages.noMatchPattern;
      this.setValidity({ patternMismatch: !0 }, t);
    }
  }
  /**
   * emits the mousedown event while preventing any unintended effects
   * from a disabled event target
   * @param event
   * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
   */
  handleMousedown(t) {
    this.emitMousedown(t), this.preventDisabledEvents(t);
  }
  /**
   * emits the keydown event while preventing any unintended effects
   * from a disabled event target
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  handleKeydown(t) {
    super.handleKeydown(t), this.preventDisabledEvents(t);
  }
}
i([
  s({ reflect: !0 })
], a.prototype, "value", 2);
i([
  s({ reflect: !0 })
], a.prototype, "label", 2);
i([
  s({ reflect: !0 })
], a.prototype, "hint", 2);
i([
  s({ reflect: !0 })
], a.prototype, "id", 2);
i([
  s()
], a.prototype, "title", 2);
i([
  s()
], a.prototype, "type", 2);
i([
  s()
], a.prototype, "max", 2);
i([
  s()
], a.prototype, "min", 2);
i([
  s({ type: Number })
], a.prototype, "maxlength", 2);
i([
  s({ type: Number })
], a.prototype, "minlength", 2);
i([
  s()
], a.prototype, "pattern", 2);
i([
  s({ type: Boolean, reflect: !0 })
], a.prototype, "invalid", 2);
i([
  s({ type: Boolean, reflect: !0 })
], a.prototype, "disabled", 2);
i([
  s({ type: Boolean, reflect: !0 })
], a.prototype, "required", 2);
i([
  s({ type: Object, attribute: "errors-map" })
], a.prototype, "errorsMap", 2);
i([
  s({ attribute: "required-message" })
], a.prototype, "requiredMessage", 2);
i([
  s({ type: Function })
], a.prototype, "customValidate", 2);
i([
  s({ type: Boolean })
], a.prototype, "disableDefaultValidation", 2);
i([
  d
], a.prototype, "setFormValue", 1);
i([
  p
], a.prototype, "prerenderFormBaseSetup", 1);
export {
  a as B,
  h as I
};
